import React from "react";
import { useB2BAuth } from "../B2BShared/B2BAuthContext/B2BAuthContext";
import { useB2BTranslation } from "../B2BShared/hooks/useB2BTranslation";
import {
  User,
  Users,
  Calendar,
  LogOut,
  ArrowRight,
  Shield,
  Settings,
  Home,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import B2BProfileCompletionAlert from "../B2BShared/B2BProfileCompletionAlert/B2BProfileCompletionAlert";
import "../B2BShared/B2BButtonStyles/B2BButtonStyles.css";
import "./B2BDashboard.css";

const B2BDashboard = () => {
  const { t, tAuth } = useB2BTranslation();
  const navigate = useNavigate();
  const { user, logout, isAdmin } = useB2BAuth();

  const handleLogout = () => {
    logout();
  };

  const dashboardCards = [
    {
      id: "member",
      title: t("dashboard.profile.title"),
      description: t("dashboard.profile.description"),
      icon: <User size={24} />,
      link: "/gcb/profile",
      colorClass: "card-member",
      gradient: "from-purple-500 to-indigo-600",
    },
    {
      id: "participants",
      title: t("dashboard.navigation.allParticipants"),
      description: t("dashboard.participantsDescription"),
      icon: <Users size={24} />,
      link: "/gcb/participants",
      colorClass: "card-participants",
      gradient: "from-orange-500 to-red-500",
    },
    {
      id: "events",
      title: t("dashboard.navigation.b2bEvents"),
      description: t("dashboard.eventsDescription"),
      icon: <Calendar size={24} />,
      link: "/gcb/dashboard/events",
      colorClass: "card-events",
      gradient: "from-slate-600 to-slate-700",
    },
    {
      id: "payments",
      title: t("dashboard.payments.title"),
      description: t("dashboard.payments.description"),
      icon: <Shield size={24} />,
      link: "https://gcbusiness.space",
      colorClass: "card-payments",
      gradient: "from-emerald-500 to-teal-600",
      external: true,
    },
    // {
    //   id: "brand-perception",
    //   title: t("dashboard.brandPerception.title"),
    //   description: t("dashboard.brandPerception.description"),
    //   icon: <User size={24} />,
    //   link: "/gcb/dashboard/brand-perception",
    //   colorClass: "card-brand",
    //   gradient: "from-amber-500 to-orange-600",
    // },
  ];

  return (
    <div className="b2b-dashboard-container">
      {/* User Info Bar */}
      <div className="user-info-bar">
        <div className="user-info-content">
          <div className="user-welcome">
            <h1 className="welcome-title">
              {t("dashboard.welcome")}, {user?.name || "User"}!
            </h1>
            <p className="welcome-subtitle">{t("dashboard.description")}</p>
          </div>
          <div className="b2b-button-group">
            {isAdmin() && (
              <button
                onClick={() => navigate("/gcb/admin/dashboard")}
                className="b2b-button b2b-button--primary"
                title="Go to Admin Dashboard"
              >
                <Settings size={16} />
                {t("dashboard.navigation.adminDashboard")}
              </button>
            )}
            <button
              onClick={() => navigate("/gcb")}
              className="b2b-button b2b-button--secondary"
              title="Go to Main GCB Page"
            >
              <Home size={16} />
              {tAuth("toMainPage")}
            </button>
            <button
              onClick={handleLogout}
              className="b2b-button b2b-button--danger"
              aria-label="Logout"
            >
              <LogOut size={16} />
              {tAuth("logout")}
            </button>
          </div>
        </div>
      </div>

      {/* Profile Completion Alert */}
      <B2BProfileCompletionAlert />

      {/* Main Dashboard Content */}
      <div className="dashboard-main-content">
        <div className="dashboard-header">
        </div>

        <div className="dashboard-grid">
          {dashboardCards.map((card, index) => {
            if (card.external) {
              return (
                <a
                  key={card.id}
                  href={card.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`dashboard-card ${card.colorClass}`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="card-background-gradient"></div>
                  <div className="card-content">
                    <div className="card-icon-wrapper">{card.icon}</div>
                    <div className="card-text">
                      <h3 className="card-title">{card.title}</h3>
                      <p className="card-description">{card.description}</p>
                    </div>
                    <div className="card-arrow">
                      <ArrowRight size={20} />
                    </div>
                  </div>
                </a>
              );
            }
            
            return (
              <Link
                key={card.id}
                to={card.link}
                className={`dashboard-card ${card.colorClass}`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="card-background-gradient"></div>
                <div className="card-content">
                  <div className="card-icon-wrapper">{card.icon}</div>
                  <div className="card-text">
                    <h3 className="card-title">{card.title}</h3>
                    <p className="card-description">{card.description}</p>
                  </div>
                  <div className="card-arrow">
                    <ArrowRight size={20} />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default B2BDashboard;
